import type {
	ListAuditLogsParams,
	PaginatedAuditLogsResponse,
} from "src/types";
import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

const auditProvider = {
	async listAuditLogs(
		params: ListAuditLogsParams = {},
	): Promise<PaginatedAuditLogsResponse> {
		const queryParams: Record<string, string | number> = {
			limit: params.limit ?? 20,
			offset: params.offset ?? 0,
		};

		// Only include filter params if they have values
		if (params.actorEmail) queryParams.actorEmail = params.actorEmail;
		if (params.resourceType) queryParams.resourceType = params.resourceType;
		if (params.resourceId) queryParams.resourceId = params.resourceId;
		if (params.actionCategory)
			queryParams.actionCategory = params.actionCategory;
		if (params.action) queryParams.action = params.action;

		const response = await apiRequest.get(withApiPath("/audit-logs"), {
			params: queryParams,
		});
		return response.data;
	},

	async getUserAuditLogs(
		userId: string,
		limit = 20,
		offset = 0,
	): Promise<PaginatedAuditLogsResponse> {
		const response = await apiRequest.get(
			withApiPath(`/users/${userId}/audit-logs`),
			{
				params: { limit, offset },
			},
		);
		return response.data;
	},
};

export default auditProvider;
